"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInitializeLocalMock = void 0;
const react_1 = require("react");
const local_mock_util_1 = require("./local-mock.util");
const useInitializeLocalMock = (context) => {
    const [load, setLoad] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const _load = (0, local_mock_util_1.initializeLocalMock)(context);
        setLoad(_load);
    }, []);
    return load;
};
exports.useInitializeLocalMock = useInitializeLocalMock;
//# sourceMappingURL=local-mock.hook.js.map